'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _isObject = require('is-object');

var _isObject2 = _interopRequireDefault(_isObject);

var _isarray = require('isarray');

var _isarray2 = _interopRequireDefault(_isarray);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (error) {
  if (!(0, _isObject2.default)(error) || (0, _keys2.default)(error).length === 0) return {
    message: 'Unknown server error'
  };
  if (error.text) return {
    message: error.text
  };
  if (error.message) return {
    message: error.message
  };
  if (error.error) return {
    message: error.error
  };
  if (error.detail) return {
    message: error.detail
  };
  return {
    fields: (0, _keys2.default)(error),
    origin: error,
    message: (0, _values2.default)(error).map(function (val) {
      if ((0, _isarray2.default)(val) && val.length > 0) return val[0];
      if ((0, _isObject2.default)(val)) return null;
      return val;
    }).filter(function (val) {
      return val !== null && ('' + val).trim().length > 0;
    }).join(' ')
  };
};